export const en = {
    auth: {
        login: 'Login',
        signOut: 'Sign Out',
        home: 'Home',
        forgotPasswordButton: 'Forgot Password',
        forgotPassword: {
            title: 'Forgot Password?',
            instructions: 'Insert your email below and we’ll send you reset instructions',
            button: 'Send Email'
        },
        resetPassword: {
            title: 'Reset Password?',
            instructions: 'Insert new password below',
            button: 'Reset'
        },
        errors: {
            userBlocked: 'Exceeded maximum number of bad login requests - must reset password',
            invalidEmail: 'Invalid email format',
            invalidCredentials: 'Invalid credentials',
            userCredentialsExpired: 'User credentials have expired - must reset password',
            /*  userNotFound: 'User not found', */
            userNotFound: "An email has been sent to your email. Follow the link provided and reset your password",
            userInactive: 'User is inactive. Please contact your system admin to reset your user.',
            invalidPassword: 'Invalid password format. Password should include at least 1 lowercase, 1 uppercase, 1 digit and 1 symbol.',
            invalidPasswordLength: 'Password should have at least %{charCount} characters',
            invalidPasswordMismatch: 'Passwords should be the same',
            sessionExpired: 'Your session has expired. Please login with your credentials.'
        },
        alerts: {
            forgot: {
                success: {
                    title: 'Forgot Password',
                    text: 'An email has been sent to your email. Follow the link provided and reset your password'
                },
                error: {
                    title: 'Forgot Password'
                }
            },
            reset: {
                success: {
                    title: 'Reset Password',
                    text: 'Your password has been reset. You can now login with your new password.'
                },
                error: {
                    title: 'Reset Password Error'
                }
            }
        }
    }
};